import { createSlice } from '@reduxjs/toolkit';

import { contentfulAPIConfig } from '../utils/configs';

const contentfulAPIToken = contentfulAPIConfig.targetId  === 'DEV' ? contentfulAPIConfig.contentfulPreviewApiToken : contentfulAPIConfig.apiToken;

const initialState = {
  contentfulToken : contentfulAPIToken,
  targetEnv: contentfulAPIConfig.targetId,
};

export const tokensSlice = createSlice({
  name: 'tokens',
  initialState,
  reducers: {},
  extraReducers: {},
});

export const {} = tokensSlice.actions; // eslint-disable-line no-empty-pattern

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
// export const selectCount = state => state.counter.value;

export default tokensSlice.reducer;
